export default __webpack_public_path__ + "46fa7ed.png";